import React, { Component } from 'react';
import { Card, CardBody, Row, Col } from "reactstrap";
import waveHand from "../../../assets/images/icons/wave.gif";

class StudentProfileCard extends Component {
    state = {
        name: JSON.parse(localStorage.getItem('user'))?.name || "Brandstrek staff",
        department: JSON.parse(localStorage.getItem('user'))?.department || "--",
        designation: JSON.parse(localStorage.getItem('user'))?.designation || "--",
        image: JSON.parse(localStorage.getItem('user'))?.profile_pic || "--",
    };

    render() {
        return (
            <React.Fragment>
                <Card>
                    <CardBody>



                        <Row className="align-items-center">
                            {/* Student Image (First Column) */}
                            <Col xs={4} md={4} lg={3}>
                                <img
                                    src={this.state.image}
                                    className="img-fluid"
                                    alt="Student"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        maxWidth: "250px", // Default size for mobile
                                        "@media (min-width: 768px)": { maxWidth: "250px" }, // Increased size for tablet
                                        "@media (min-width: 992px)": { maxWidth: "300px" }, // Increased size for laptop/desktop
                                    }}
                                />
                            </Col>
                            {/* Student Details (Second Column) */}
                            <Col xs={8} md={8} lg={9}>
                                <div className="">
                                    <h5>
                                        Welcome - {this.state.name}  <img src={waveHand} className="img-fluid" width={30} alt="Wave" />
                                    </h5>
                                    <h6>
                                        {this.state.department}
                                    </h6>
                                    <p>
                                        {this.state.designation}
                                    </p>


                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

export default StudentProfileCard;